import DashboardContainer from "../../container/admin/dashboard";

const DashboardView = () => {
    return <DashboardContainer />;
};

export default DashboardView;
